<template>
  <v-card :elevation="$root.ele" class="mt-5">
    <v-data-table
      :search="search"
      :headers="headers"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, -1],
      }"
      :items-per-page="50"
      class="templates-table"
      :items="list"
    >
      <template v-slot:top>
        <div class="pa-5">
          <v-text-field
            label="Search Make"
            hide-details=""
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
          >
          </v-text-field>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn icon @click="$router.push(`/car-make-unlocking/${item.id}`)">
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.no_models="{ item }">
        {{ item.models.length }}
      </template>
      <template v-slot:item.updated_by="{ item }">
        {{ updated(item) }}
      </template>
      <template v-slot:item.name="{ item }">
        <div class="text-capitalize">
          {{ item.name }}
        </div>
      </template>
    </v-data-table>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import customerModal from "../../assets/js/customer.modal";
import { carMakeUnlocking } from "../../assets/js/firebase";
import types from "../../assets/js/types";
export default {
  data() {
    return {
      lastDoc: null,
      types: types,
      search: "",
      id: "",
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "ID", value: "make_id" },
        { text: "NAME", value: "name" },
        { text: "NUMBER OF MODELS", value: "no_models" },
        { text: "UPDATED ON", value: "updated" },
        { text: "UPDATED BY", value: "updated_by" },
        { text: "ACTION", value: "action" },
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true,
        };
        if (value === "action") doc.divider = false;
        list.push(doc);
      }
      return list;
    },
    list() {
      return this.$store.getters.makesUnlocking;
    },
  },
  methods: {
    updated({ updated_by }) {
      let name = updated_by;
      this.list.forEach((item) => {
        let { email, first_name, last_name } = item;
        if (email === updated_by) name = `${first_name} ${last_name}`;
      });
      return name;
    },
    type({ type }) {
      let name = "";
      this.types.forEach((item) => {
        if (item.value === type) name = item.name;
      });
      return name;
    },
    async importCategory(data) {
      let models = data.models;
      let conditions = this.$store.getters.fieldConditions;
      conditions = [...conditions].filter((i) => {
        let fields = i.perform.filter((i) => {
          return (
            [
              customerModal.KEY_CATEGORY,
              customerModal.APPLICABLE_ITEM_NUMBERS,
            ].indexOf(i.field) != -1
          );
        });
        let makeField = i.conditions.find((c) => {
          return c.value == data.id;
        });
        return fields.length == 2 && makeField != null;
      });
      let grouping = {};
      for (let item of conditions) {
        let keyCategory = item.perform.find(
          (i) => i.field == customerModal.KEY_CATEGORY
        );
        let applicable = item.perform.find(
          (i) => i.field == customerModal.APPLICABLE_ITEM_NUMBERS
        );
        let model = item.conditions.find((i) => i.field == customerModal.MODEL);
        if (applicable && keyCategory && model) {
          let key = `${keyCategory.value}||${applicable.value}||${model.value}`;
          if (grouping[key] == undefined) {
            grouping[key] = [];
          }
          grouping[key].push(item);
        }
      }
      for (let key of Object.keys(grouping)) {
        let years = grouping[key]
          .map((i) => {
            let year = i.conditions.find((i) => i.field == customerModal.YEAR);
            return year.value;
          })
          .sort();
        let from = years[0];
        let to = years[years.length - 1];
        let split = key.split("||");
        let doc = {
          from,
          to,
          name: split[2],
          key_category: split[0],
          app_item_no: split[1],
        };
        let index = models.findIndex((i) => {
          return i.name == doc.name && i.from == doc.from && i.to == doc.to;
        });
        if (index == -1) {
          models.unshift(doc);
        } else {
          models[index] = doc;
        }
      }
      await carMakeUnlocking.doc(data.id).update({
        models,
      });
      console.log("import done form", data.name);
    },
  },
};
</script>

<style lang="scss"></style>
